import { makeObservable, observable } from 'mobx'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { BackendConfigModel } from './BackendConfigModel'
import { Cubit } from './core'

export class ProfileCubit extends Cubit {
  repository: FirebaseRepository

  moderationConfig: BackendConfigModel
  gradingConfig: BackendConfigModel
  transcriptionConfig: BackendConfigModel

  @observable
  slideDecksInitialized = false

  constructor(repository: FirebaseRepository) {
    super()
    this.repository = repository

    this.moderationConfig = new BackendConfigModel(
      this.repository,
      'moderation_config'
    )
    this.gradingConfig = new BackendConfigModel(
      this.repository,
      'grading_config'
    )
    this.transcriptionConfig = new BackendConfigModel(
      this.repository,
      'transcription_config'
    )

    makeObservable(this)
  }
}
